import TimeValue from './TimeValue.js';

export class MsecDuratives {
  static name = 'MsecDuratives';

  constructor(begin, end) {
    this.begin = (begin === null)? null : begin.clone();
    this.end = (end === null)? null : end.clone();
  }

  static generateFromRawObj(beginMsec, endMsec) {
    return new this(
      (beginMsec === null)? null : TimeValue.msec(beginMsec),
      (endMsec === null)? null : TimeValue.msec(endMsec),
    );
  }

  clone() {
    return new this.constructor(
      (this.begin === null)? null : this.begin.clone(),
      (this.end === null)? null : this.end.clone(),
    );
  }

  isSameAs(that) {
    return isBeginOrEndSame(this.begin, that.begin) && isBeginOrEndSame(this.end, that.end);

    function isBeginOrEndSame(thisBeginOrEnd, thatBeginOrEnd) {
      if (thisBeginOrEnd === null) {
        if (thatBeginOrEnd === null) {
          return true;
        } else {
          return false;
        }
      } else {
        if (thatBeginOrEnd === null) {
          return false;
        } else {
          return thisBeginOrEnd.isSameAs(thatBeginOrEnd);
        }
      }
    }
  }

  isEqualTo(that) {
    return isBeginOrEndEqualTo(this.begin, that.begin) && isBeginOrEndEqualTo(this.end, that.end);

    function isBeginOrEndEqualTo(thisBeginOrEnd, thatBeginOrEnd) {
      if (thisBeginOrEnd === null) {
        if (thatBeginOrEnd === null) {
          return true;
        } else {
          return false;
        }
      } else {
        if (thatBeginOrEnd === null) {
          return false;
        } else {
          return thisBeginOrEnd.isEqualTo(thatBeginOrEnd);
        }
      }
    }
  }

  generateRawObj() {
    return {
      begin: (this.begin === null)? null : this.begin.msec,
      end: (this.end === null)? null : this.end.msec,
    };
  }

  assign({ begin, end } = { begin: undefined, end: undefined }) {
    if (begin !== undefined) {
      if (begin === null) {
        this.begin = begin;
      } else {
        if (this.begin === null) {
          this.begin = begin.clone();
        } else {
          this.begin.assign(begin);
        }
      }
    }
    if (end !== undefined) {
      if (end === null) {
        this.end = end;
      } else {
        if (this.end === null) {
          this.end = end.clone();
        } else {
          this.end.assign(end);
        }
      }
    }
    return this;
  }
  
  isInRange(time) {
    let isTimeEqualsToOrMoreThanBegin = (this.begin === null)? true : time.isGreaterThanOrEqualTo(this.begin);
    let isTimeLessThanEnd = (this.end === null)? true : time.isLessThanOrEqualTo(this.end);
    return isTimeEqualsToOrMoreThanBegin && isTimeLessThanEnd;
  }

  get duration() {
    if (this.begin === null) return null;
    if (this.end === null) return null;
    return this.end.getOffsetFrom(this.begin);
  }
}

export default MsecDuratives;